<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiContentSave } from "@mdi/js";
export default {
  name: "MdiContentSave",
  data() {
    return {
      svgPath: mdiContentSave,
    };
  },
};
</script>
